import { baseApi } from "./base.api";

export const rolesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchRoles: build.query({
      query: (params) => ({ url: "/roles/fetch", method: "GET", params }),
      providesTags: ["Role"],
    }),
    fetchRolesAll: build.query({
      query: () => ({ url: "/roles/fetch/all", method: "GET" }),
      providesTags: ["Role"],
    }),
    fetchTrashedRoles: build.query({
      query: (params) => ({ url: "/roles/fetch/trashed", method: "GET", params }),
      providesTags: ["Role"],
    }),
    fetchRoleById: build.query({
      query: (id) => ({ url: `/roles/fetch/${id}`, method: "GET" }),
      providesTags: ["Role"],
    }),
    createRole: build.mutation({
      query: (body) => ({ url: "/roles/create", method: "POST", body }),
      invalidatesTags: ["Role", "Permission"],
    }),
    updateRole: build.mutation({
      query: ({ id, body }) => ({ url: `/roles/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["Role", "Permission"],
    }),
    restoreRole: build.mutation({
      query: (id) => ({ url: `/roles/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["Role"],
    }),
    bulkRestoreRoles: build.mutation({
      query: (body) => ({ url: "/roles/bulk-restore", method: "POST", body }),
      invalidatesTags: ["Role"],
    }),
    deleteRole: build.mutation({
      query: (id) => ({ url: `/roles/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["Role"],
    }),
    bulkDeleteRoles: build.mutation({
      query: (body) => ({ url: "/roles/bulk-delete", method: "POST", body }),
      invalidatesTags: ["Role"],
    }),
    destroyRole: build.mutation({
      query: (id) => ({ url: `/roles/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["Role"],
    }),
    bulkDestroyRoles: build.mutation({
      query: (body) => ({ url: "/roles/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["Role"],
    }),
  }),
});

export const {
  useFetchRolesQuery,
  useFetchRolesAllQuery,
  useFetchTrashedRolesQuery,
  useFetchRoleByIdQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useRestoreRoleMutation,
  useBulkRestoreRolesMutation,
  useDeleteRoleMutation,
  useBulkDeleteRolesMutation,
  useDestroyRoleMutation,
  useBulkDestroyRolesMutation,
} = rolesApi;
